// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { isNullOrUndefined, isNumber, isObject, isString, objDefineProps } from "@nevware21/ts-utils";
import { _DYN_SPAN_ID, _DYN_TRACE_FLAGS, _DYN_TRACE_ID, _DYN_TRACE_STATE } from "../../../__DynamicConstants";
import { INVALID_SPAN_ID, INVALID_TRACE_ID, isValidSpanId, isValidTraceId } from "../../../utils/TraceParent";
import { createOTelTraceState } from "./traceState";
export function createOTelSpanContext(traceContext) {
    var traceId = isValidTraceId(traceContext[_DYN_TRACE_ID /* @min:%2etraceId */]) ? traceContext[_DYN_TRACE_ID /* @min:%2etraceId */] : INVALID_TRACE_ID;
    var spanId = isValidSpanId(traceContext[_DYN_SPAN_ID /* @min:%2espanId */]) ? traceContext[_DYN_SPAN_ID /* @min:%2espanId */] : INVALID_SPAN_ID;
    var isRemote = traceContext.isRemote;
    var traceFlags = (!isNullOrUndefined(traceContext[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]) ? traceContext[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */] : 1 /* eW3CTraceFlags.Sampled */);
    var otTraceState = null;
    var traceContextObj = {
        traceId: traceId,
        spanId: spanId,
        traceFlags: traceFlags
    };
    return objDefineProps(traceContextObj, {
        traceId: {
            g: function () { return traceId; },
            s: function (value) { return traceId = isValidTraceId(value) ? value : INVALID_TRACE_ID; }
        },
        spanId: {
            g: function () { return spanId; },
            s: function (value) { return spanId = isValidSpanId(value) ? value : INVALID_SPAN_ID; }
        },
        isRemote: {
            g: function () { return isRemote; }
        },
        traceFlags: {
            g: function () { return traceFlags; },
            s: function (value) { return traceFlags = value; }
        },
        traceState: {
            g: function () {
                if (!otTraceState) {
                    // The Trace State has changed, update the local copy
                    otTraceState = createOTelTraceState(traceContext[_DYN_TRACE_STATE /* @min:%2etraceState */]);
                }
                return otTraceState;
            },
            s: function (value) {
                // The Trace State has changed, update the local copy
                otTraceState = value;
            }
        }
    });
}
export function isSpanContext(spanContext) {
    return spanContext && isObject(spanContext) && isString(spanContext[_DYN_TRACE_ID /* @min:%2etraceId */]) && isString(spanContext[_DYN_SPAN_ID /* @min:%2espanId */]) && isNumber(spanContext[_DYN_TRACE_FLAGS /* @min:%2etraceFlags */]);
}
export function wrapDistributedTrace(traceContext) {
    return createOTelSpanContext(traceContext);
}
//# sourceMappingURL=spanContext.js.map